import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerScanPromoterInfoListDataApi(data) {
  return request({
    url: "web/appConsumerScanPromoterInfo/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppConsumerScanPromoterInfoExportDataApi(data) {
  return request({
    url: "web/appConsumerScanPromoterInfo/exportData",
    method: "post",
    data
  });
}